// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --nav-height: 70px;
  --sidebar-bg: #0b1120;
  --sidebar-color: #94a3b8;
  --sidebar-active-bg: #1e293b;
  --sidebar-active-color: #fff;
  --header-height: 70px;
  --primary-color: #0d6efd;
  --bg-light: #f8fafc;
}

body {
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
  background-color: var(--bg-light);
  color: #1e293b;
}

/* Horizontal Navigation */
.horizontal-nav {
  width: 100%;
  height: var(--nav-height);
  position: fixed;
  top: 0;
  left: 0;
  background-color: var(--sidebar-bg);
  color: var(--sidebar-color);
  z-index: 1050;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.nav-container {
  height: 100%;
  padding: 0 1.5rem;
}

.sidebar-logo h5 {
  color: #fff;
  margin: 0;
  font-weight: 800;
  letter-spacing: 1px;
  white-space: nowrap;
}

.nav-items-wrapper {
  overflow-x: auto;
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none;  /* IE and Edge */
}

.nav-items-wrapper::-webkit-scrollbar {
  display: none; /* Chrome, Safari and Opera */
}

.nav-item-link {
  display: flex;
  align-items: center;
  padding: 0 1.25rem;
  height: var(--nav-height);
  color: var(--sidebar-color);
  text-decoration: none;
  transition: all 0.2s;
  font-size: 0.95rem;
  font-weight: 500;
  white-space: nowrap;
  border-bottom: 3px solid transparent;
}

.nav-item-link i {
  font-size: 1.2rem;
}

.nav-item-link:hover {
  background-color: var(--sidebar-active-bg);
  color: var(--sidebar-active-color);
}

.nav-item-link.active {
  background-color: var(--sidebar-active-bg);
  color: var(--sidebar-active-color);
  border-bottom-color: var(--primary-color);
}

/* Responsive Horizontal Nav */
@media (max-width: 991.98px) {
  .nav-item-link {
    padding: 0 0.75rem;
    font-size: 0.85rem;
  }
  
  .nav-item-link i {
    font-size: 1.1rem;
    margin-right: 0.5rem !important;
  }
}

@media (max-width: 575.98px) {
  .sidebar-logo {
    margin-right: 1rem !important;
  }
  
  .sidebar-logo h5 {
    font-size: 1.1rem;
  }
  
  .nav-item-link .link-text {
    display: none;
  }
  
  .nav-item-link i {
    margin-right: 0 !important;
    font-size: 1.3rem;
  }
}

.back-btn {
  width: 35px;
  height: 35px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

/* Header */
.top-header {
  display: none; /* Hidden in horizontal layout */
}

/* Main Content */
.main-wrapper {
  padding-top: var(--nav-height);
  min-height: 100vh;
  transition: all 0.3s ease-in-out;
}

.content-container {
  padding: 1.5rem;
}

/* Cards & Components */
.card {
  border: 1px solid #e2e8f0;
  border-radius: 0.75rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  transition: transform 0.2s, box-shadow 0.2s;
}

.card:hover {
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
}

.card-header {
  background-color: #fff;
  border-bottom: 1px solid #f1f5f9;
  padding: 1.25rem 1.5rem;
}

.custom-pills .nav-link {
  border-radius: 0.5rem;
  font-size: 0.75rem;
  transition: all 0.2s;
}

.custom-pills .nav-link.active {
  background-color: var(--primary-color);
  color: #fff;
}

.custom-pills .nav-link:not(.active):hover {
  background-color: #f1f5f9;
}

.stats-card {
  padding: 1.5rem;
}

.stats-icon {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
  margin-bottom: 1rem;
}

.dashboard-summary-card {
  border-radius: 1rem;
  overflow: hidden;
}

.dashboard-summary-card--blue {
  background: linear-gradient(180deg, #f2f8ff 0%, #eef7ff 100%);
}

.dashboard-summary-card--violet {
  background: linear-gradient(180deg, #f7f3ff 0%, #f5f0ff 100%);
}

.dashboard-summary-card--teal {
  background: linear-gradient(180deg, #edfdfb 0%, #ebfbf8 100%);
}

.dashboard-summary-card--amber {
  background: linear-gradient(180deg, #fff8ee 0%, #fff6ea 100%);
}

.dashboard-summary-card--slate {
  background: linear-gradient(180deg, #f7fbff 0%, #f2f7fb 100%);
}

.dashboard-summary-icon {
  width: 52px;
  height: 52px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.25rem;
  color: #fff;
  box-shadow: 0 8px 20px rgba(15, 23, 42, 0.10);
}

.dashboard-summary-icon--blue {
  background: linear-gradient(135deg, #4f9cf9 0%, #2563eb 100%);
}

.dashboard-summary-icon--violet {
  background: linear-gradient(135deg, #c084fc 0%, #8b5cf6 100%);
}

.dashboard-summary-icon--teal {
  background: linear-gradient(135deg, #2dd4bf 0%, #14b8a6 100%);
}

.dashboard-summary-icon--amber {
  background: linear-gradient(135deg, #fbbf24 0%, #f59e0b 100%);
}

.dashboard-summary-icon--slate {
  background: linear-gradient(135deg, #60a5fa 0%, #3b82f6 100%);
}

.dashboard-summary-chip {
  border-radius: 999px;
  padding: 0.35rem 0.8rem;
  font-size: 0.72rem;
  font-weight: 700;
  line-height: 1;
}

.dashboard-summary-chip--blue {
  background-color: #dcfce7;
  color: #15803d;
}

.dashboard-summary-chip--violet {
  background-color: #ede9fe;
  color: #7c3aed;
}

.dashboard-summary-chip--teal {
  background-color: #ccfbf1;
  color: #0f766e;
}

.dashboard-summary-chip--amber {
  background-color: #fef3c7;
  color: #b45309;
}

.dashboard-summary-title {
  font-size: 0.98rem;
  font-weight: 700;
  color: #1e293b;
  margin-bottom: 0.4rem;
}

.dashboard-summary-value {
  font-size: 2rem;
  font-weight: 800;
  color: #0f172a;
  line-height: 1.1;
}

.dashboard-summary-split {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  margin-top: 1.2rem;
  border-top: 1px solid rgba(148, 163, 184, 0.22);
}

.dashboard-summary-split-item {
  padding-top: 0.85rem;
}

.dashboard-summary-split-item + .dashboard-summary-split-item {
  border-left: 1px solid rgba(148, 163, 184, 0.22);
  padding-left: 1rem;
  margin-left: 1rem;
}

.dashboard-summary-split-label,
.dashboard-summary-stat-label {
  font-size: 0.82rem;
  color: #475569;
  font-weight: 600;
}

.dashboard-summary-split-value,
.dashboard-summary-stat-value {
  font-size: 1.15rem;
  font-weight: 800;
  line-height: 1.2;
  margin-top: 0.25rem;
}

.dashboard-summary-stats {
  display: grid;
  gap: 0.85rem;
  margin-top: 1rem;
}

.dashboard-summary-stats--3 {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.dashboard-summary-stats--2 {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.dashboard-summary-dot {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  margin-right: 0.4rem;
  vertical-align: middle;
}

.dashboard-mini-card {
  border-radius: 0.9rem;
}

.dashboard-mini-title {
  color: #64748b;
  font-size: 0.82rem;
  font-weight: 700;
}

.dashboard-mini-value {
  color: #0f172a;
  font-size: 2rem;
  font-weight: 800;
  line-height: 1.1;
}

.dashboard-header-select {
  min-width: 220px;
}

/* Responsive tuning: keep dashboard cards compact on tablets and phones */
@media (max-width: 1199.98px) {
  .dashboard-summary-value {
    font-size: 1.75rem;
  }

  .dashboard-mini-value {
    font-size: 1.75rem;
  }
}

@media (max-width: 991.98px) {
  .dashboard-header-select {
    min-width: 0;
    width: 100%;
  }

  .dashboard-summary-icon {
    width: 42px;
    height: 42px;
    font-size: 1.05rem;
  }

  .dashboard-summary-chip {
    padding: 0.28rem 0.65rem;
    font-size: 0.68rem;
  }

  .dashboard-summary-title {
    font-size: 0.92rem;
  }

  .dashboard-summary-value,
  .dashboard-mini-value {
    font-size: 1.5rem;
  }

  .dashboard-mini-title {
    font-size: 0.76rem;
  }

  .dashboard-summary-split {
    margin-top: 0.9rem;
  }

  .dashboard-summary-split-item {
    padding-top: 0.65rem;
  }

  .dashboard-summary-split-item + .dashboard-summary-split-item {
    padding-left: 0.75rem;
    margin-left: 0.75rem;
  }

  .dashboard-summary-split-label,
  .dashboard-summary-stat-label {
    font-size: 0.76rem;
  }

  .dashboard-summary-split-value,
  .dashboard-summary-stat-value {
    font-size: 1rem;
  }

  .dashboard-summary-stats {
    gap: 0.6rem;
    margin-top: 0.85rem;
  }

  .dashboard-page .card-header {
    padding-left: 1rem !important;
    padding-right: 1rem !important;
    padding-top: 1.15rem !important;
  }

  .dashboard-page .card-body.px-4,
  .dashboard-page .card-body.p-4 {
    padding: 1rem !important;
  }

  .dashboard-page .card-body.px-4 {
    padding-top: 0.5rem !important;
  }
}

@media (max-width: 575.98px) {
  .dashboard-summary-value,
  .dashboard-mini-value {
    font-size: 1.4rem;
  }

  .dashboard-summary-stat-label {
    font-size: 0.7rem;
  }

  .dashboard-summary-stat-value {
    font-size: 0.95rem;
  }

  .dashboard-summary-dot {
    width: 6px;
    height: 6px;
    margin-right: 0.3rem;
  }

  .dashboard-page .card-body.p-4,
  .dashboard-page .card-body.px-4 {
    padding: 0.9rem !important;
  }

  .dashboard-page .card-body.px-0 {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
}

.table thead th {
  background-color: #f8fafc;
  color: #64748b;
  font-size: 0.75rem;
  text-transform: uppercase;
  font-weight: 700;
  letter-spacing: 0.5px;
  padding: 0.75rem 1.5rem;
  border-bottom: 1px solid #e2e8f0;
}

.table tbody td {
  padding: 1rem 1.5rem;
  font-size: 0.875rem;
  vertical-align: middle;
}

.badge {
  padding: 0.4em 0.75em;
  font-weight: 600;
  border-radius: 6px;
}

.badge-soft-success {
  background-color: #dcfce7;
  color: #15803d;
}

.badge-soft-warning {
  background-color: #fef9c3;
  color: #854d0e;
}

.badge-soft-danger {
  background-color: #fee2e2;
  color: #b91c1c;
}

.badge-soft-primary {
  background-color: #dbeafe;
  color: #1d4ed8;
}

.badge-soft-info {
  background-color: #cffafe;
  color: #0e7490;
}

.badge-soft-secondary {
  background-color: #e2e8f0;
  color: #475569;
}

/* Soft Backgrounds */
.bg-soft-primary { background-color: #eff6ff !important; }
.bg-soft-success { background-color: #f0fdf4 !important; }
.bg-soft-warning { background-color: #fffbeb !important; }
.bg-soft-danger { background-color: #fef2f2 !important; }
.bg-soft-info { background-color: #f0f9ff !important; }
.bg-soft-dark { background-color: #f1f5f9 !important; }

.text-primary { color: #2563eb !important; }
.text-success { color: #16a34a !important; }
.text-warning { color: #d97706 !important; }
.text-danger { color: #dc2626 !important; }
.text-info { color: #0891b2 !important; }

/* Buttons */
.btn {
  font-weight: 500;
  padding: 0.5rem 1rem;
  border-radius: 0.5rem;
}

.btn-primary {
  background-color: #2563eb;
  border-color: #2563eb;
}

.btn-primary:hover {
  background-color: #1d4ed8;
  border-color: #1d4ed8;
}

/* Utilities */
.text-xs { font-size: 0.75rem; }
.text-sm { font-size: 0.875rem; }
.fw-600 { font-weight: 600; }
.fw-700 { font-weight: 700; }
`, "",{"version":3,"sources":["webpack://./src/assets/css/modern-ui.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,wBAAwB;EACxB,4BAA4B;EAC5B,4BAA4B;EAC5B,qBAAqB;EACrB,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,yGAAyG;EACzG,iCAAiC;EACjC,cAAc;AAChB;;AAEA,0BAA0B;AAC1B;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;EACf,MAAM;EACN,OAAO;EACP,mCAAmC;EACnC,2BAA2B;EAC3B,aAAa;EACb,yCAAyC;AAC3C;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,SAAS;EACT,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB,EAAE,YAAY;EACnC,wBAAwB,GAAG,gBAAgB;AAC7C;;AAEA;EACE,aAAa,EAAE,6BAA6B;AAC9C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,2BAA2B;EAC3B,qBAAqB;EACrB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,oCAAoC;AACtC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,0CAA0C;EAC1C,kCAAkC;AACpC;;AAEA;EACE,0CAA0C;EAC1C,kCAAkC;EAClC,yCAAyC;AAC3C;;AAEA,8BAA8B;AAC9B;EACE;IACE,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,+BAA+B;EACjC;AACF;;AAEA;EACE;IACE,6BAA6B;EAC/B;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,0BAA0B;IAC1B,iBAAiB;EACnB;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA,WAAW;AACX;EACE,aAAa,EAAE,gCAAgC;AACjD;;AAEA,iBAAiB;AACjB;EACE,8BAA8B;EAC9B,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,eAAe;AACjB;;AAEA,uBAAuB;AACvB;EACE,yBAAyB;EACzB,sBAAsB;EACtB,yCAAyC;EACzC,2CAA2C;AAC7C;;AAEA;EACE,iFAAiF;AACnF;;AAEA;EACE,sBAAsB;EACtB,gCAAgC;EAChC,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,sCAAsC;EACtC,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,WAAW;EACX,6CAA6C;AAC/C;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,oBAAoB;EACpB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,kBAAkB;EAClB,+CAA+C;AACjD;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,gDAAgD;EAChD,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;;EAEE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,0EAA0E;AAC1E;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,wBAAwB;IACxB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;;IAEE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,qBAAqB;IACrB,oBAAoB;EACtB;;EAEA;;IAEE,kBAAkB;EACpB;;EAEA;;IAEE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,6BAA6B;IAC7B,8BAA8B;IAC9B,+BAA+B;EACjC;;EAEA;;IAEE,wBAAwB;EAC1B;;EAEA;IACE,8BAA8B;EAChC;AACF;;AAEA;EACE;;IAEE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,UAAU;IACV,WAAW;IACX,oBAAoB;EACtB;;EAEA;;IAEE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;IAC1B,2BAA2B;EAC7B;AACF;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,qBAAqB;EACrB,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA,qBAAqB;AACrB,mBAAmB,oCAAoC,EAAE;AACzD,mBAAmB,oCAAoC,EAAE;AACzD,mBAAmB,oCAAoC,EAAE;AACzD,kBAAkB,oCAAoC,EAAE;AACxD,gBAAgB,oCAAoC,EAAE;AACtD,gBAAgB,oCAAoC,EAAE;;AAEtD,gBAAgB,yBAAyB,EAAE;AAC3C,gBAAgB,yBAAyB,EAAE;AAC3C,gBAAgB,yBAAyB,EAAE;AAC3C,eAAe,yBAAyB,EAAE;AAC1C,aAAa,yBAAyB,EAAE;;AAExC,YAAY;AACZ;EACE,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,cAAc;AACd,WAAW,kBAAkB,EAAE;AAC/B,WAAW,mBAAmB,EAAE;AAChC,UAAU,gBAAgB,EAAE;AAC5B,UAAU,gBAAgB,EAAE","sourcesContent":[":root {\n  --nav-height: 70px;\n  --sidebar-bg: #0b1120;\n  --sidebar-color: #94a3b8;\n  --sidebar-active-bg: #1e293b;\n  --sidebar-active-color: #fff;\n  --header-height: 70px;\n  --primary-color: #0d6efd;\n  --bg-light: #f8fafc;\n}\n\nbody {\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Helvetica, Arial, sans-serif;\n  background-color: var(--bg-light);\n  color: #1e293b;\n}\n\n/* Horizontal Navigation */\n.horizontal-nav {\n  width: 100%;\n  height: var(--nav-height);\n  position: fixed;\n  top: 0;\n  left: 0;\n  background-color: var(--sidebar-bg);\n  color: var(--sidebar-color);\n  z-index: 1050;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n}\n\n.nav-container {\n  height: 100%;\n  padding: 0 1.5rem;\n}\n\n.sidebar-logo h5 {\n  color: #fff;\n  margin: 0;\n  font-weight: 800;\n  letter-spacing: 1px;\n  white-space: nowrap;\n}\n\n.nav-items-wrapper {\n  overflow-x: auto;\n  scrollbar-width: none; /* Firefox */\n  -ms-overflow-style: none;  /* IE and Edge */\n}\n\n.nav-items-wrapper::-webkit-scrollbar {\n  display: none; /* Chrome, Safari and Opera */\n}\n\n.nav-item-link {\n  display: flex;\n  align-items: center;\n  padding: 0 1.25rem;\n  height: var(--nav-height);\n  color: var(--sidebar-color);\n  text-decoration: none;\n  transition: all 0.2s;\n  font-size: 0.95rem;\n  font-weight: 500;\n  white-space: nowrap;\n  border-bottom: 3px solid transparent;\n}\n\n.nav-item-link i {\n  font-size: 1.2rem;\n}\n\n.nav-item-link:hover {\n  background-color: var(--sidebar-active-bg);\n  color: var(--sidebar-active-color);\n}\n\n.nav-item-link.active {\n  background-color: var(--sidebar-active-bg);\n  color: var(--sidebar-active-color);\n  border-bottom-color: var(--primary-color);\n}\n\n/* Responsive Horizontal Nav */\n@media (max-width: 991.98px) {\n  .nav-item-link {\n    padding: 0 0.75rem;\n    font-size: 0.85rem;\n  }\n  \n  .nav-item-link i {\n    font-size: 1.1rem;\n    margin-right: 0.5rem !important;\n  }\n}\n\n@media (max-width: 575.98px) {\n  .sidebar-logo {\n    margin-right: 1rem !important;\n  }\n  \n  .sidebar-logo h5 {\n    font-size: 1.1rem;\n  }\n  \n  .nav-item-link .link-text {\n    display: none;\n  }\n  \n  .nav-item-link i {\n    margin-right: 0 !important;\n    font-size: 1.3rem;\n  }\n}\n\n.back-btn {\n  width: 35px;\n  height: 35px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n/* Header */\n.top-header {\n  display: none; /* Hidden in horizontal layout */\n}\n\n/* Main Content */\n.main-wrapper {\n  padding-top: var(--nav-height);\n  min-height: 100vh;\n  transition: all 0.3s ease-in-out;\n}\n\n.content-container {\n  padding: 1.5rem;\n}\n\n/* Cards & Components */\n.card {\n  border: 1px solid #e2e8f0;\n  border-radius: 0.75rem;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);\n  transition: transform 0.2s, box-shadow 0.2s;\n}\n\n.card:hover {\n  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);\n}\n\n.card-header {\n  background-color: #fff;\n  border-bottom: 1px solid #f1f5f9;\n  padding: 1.25rem 1.5rem;\n}\n\n.custom-pills .nav-link {\n  border-radius: 0.5rem;\n  font-size: 0.75rem;\n  transition: all 0.2s;\n}\n\n.custom-pills .nav-link.active {\n  background-color: var(--primary-color);\n  color: #fff;\n}\n\n.custom-pills .nav-link:not(.active):hover {\n  background-color: #f1f5f9;\n}\n\n.stats-card {\n  padding: 1.5rem;\n}\n\n.stats-icon {\n  width: 48px;\n  height: 48px;\n  border-radius: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.5rem;\n  margin-bottom: 1rem;\n}\n\n.dashboard-summary-card {\n  border-radius: 1rem;\n  overflow: hidden;\n}\n\n.dashboard-summary-card--blue {\n  background: linear-gradient(180deg, #f2f8ff 0%, #eef7ff 100%);\n}\n\n.dashboard-summary-card--violet {\n  background: linear-gradient(180deg, #f7f3ff 0%, #f5f0ff 100%);\n}\n\n.dashboard-summary-card--teal {\n  background: linear-gradient(180deg, #edfdfb 0%, #ebfbf8 100%);\n}\n\n.dashboard-summary-card--amber {\n  background: linear-gradient(180deg, #fff8ee 0%, #fff6ea 100%);\n}\n\n.dashboard-summary-card--slate {\n  background: linear-gradient(180deg, #f7fbff 0%, #f2f7fb 100%);\n}\n\n.dashboard-summary-icon {\n  width: 52px;\n  height: 52px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.25rem;\n  color: #fff;\n  box-shadow: 0 8px 20px rgba(15, 23, 42, 0.10);\n}\n\n.dashboard-summary-icon--blue {\n  background: linear-gradient(135deg, #4f9cf9 0%, #2563eb 100%);\n}\n\n.dashboard-summary-icon--violet {\n  background: linear-gradient(135deg, #c084fc 0%, #8b5cf6 100%);\n}\n\n.dashboard-summary-icon--teal {\n  background: linear-gradient(135deg, #2dd4bf 0%, #14b8a6 100%);\n}\n\n.dashboard-summary-icon--amber {\n  background: linear-gradient(135deg, #fbbf24 0%, #f59e0b 100%);\n}\n\n.dashboard-summary-icon--slate {\n  background: linear-gradient(135deg, #60a5fa 0%, #3b82f6 100%);\n}\n\n.dashboard-summary-chip {\n  border-radius: 999px;\n  padding: 0.35rem 0.8rem;\n  font-size: 0.72rem;\n  font-weight: 700;\n  line-height: 1;\n}\n\n.dashboard-summary-chip--blue {\n  background-color: #dcfce7;\n  color: #15803d;\n}\n\n.dashboard-summary-chip--violet {\n  background-color: #ede9fe;\n  color: #7c3aed;\n}\n\n.dashboard-summary-chip--teal {\n  background-color: #ccfbf1;\n  color: #0f766e;\n}\n\n.dashboard-summary-chip--amber {\n  background-color: #fef3c7;\n  color: #b45309;\n}\n\n.dashboard-summary-title {\n  font-size: 0.98rem;\n  font-weight: 700;\n  color: #1e293b;\n  margin-bottom: 0.4rem;\n}\n\n.dashboard-summary-value {\n  font-size: 2rem;\n  font-weight: 800;\n  color: #0f172a;\n  line-height: 1.1;\n}\n\n.dashboard-summary-split {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  margin-top: 1.2rem;\n  border-top: 1px solid rgba(148, 163, 184, 0.22);\n}\n\n.dashboard-summary-split-item {\n  padding-top: 0.85rem;\n}\n\n.dashboard-summary-split-item + .dashboard-summary-split-item {\n  border-left: 1px solid rgba(148, 163, 184, 0.22);\n  padding-left: 1rem;\n  margin-left: 1rem;\n}\n\n.dashboard-summary-split-label,\n.dashboard-summary-stat-label {\n  font-size: 0.82rem;\n  color: #475569;\n  font-weight: 600;\n}\n\n.dashboard-summary-split-value,\n.dashboard-summary-stat-value {\n  font-size: 1.15rem;\n  font-weight: 800;\n  line-height: 1.2;\n  margin-top: 0.25rem;\n}\n\n.dashboard-summary-stats {\n  display: grid;\n  gap: 0.85rem;\n  margin-top: 1rem;\n}\n\n.dashboard-summary-stats--3 {\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n}\n\n.dashboard-summary-stats--2 {\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n}\n\n.dashboard-summary-dot {\n  display: inline-block;\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  margin-right: 0.4rem;\n  vertical-align: middle;\n}\n\n.dashboard-mini-card {\n  border-radius: 0.9rem;\n}\n\n.dashboard-mini-title {\n  color: #64748b;\n  font-size: 0.82rem;\n  font-weight: 700;\n}\n\n.dashboard-mini-value {\n  color: #0f172a;\n  font-size: 2rem;\n  font-weight: 800;\n  line-height: 1.1;\n}\n\n.dashboard-header-select {\n  min-width: 220px;\n}\n\n/* Responsive tuning: keep dashboard cards compact on tablets and phones */\n@media (max-width: 1199.98px) {\n  .dashboard-summary-value {\n    font-size: 1.75rem;\n  }\n\n  .dashboard-mini-value {\n    font-size: 1.75rem;\n  }\n}\n\n@media (max-width: 991.98px) {\n  .dashboard-header-select {\n    min-width: 0;\n    width: 100%;\n  }\n\n  .dashboard-summary-icon {\n    width: 42px;\n    height: 42px;\n    font-size: 1.05rem;\n  }\n\n  .dashboard-summary-chip {\n    padding: 0.28rem 0.65rem;\n    font-size: 0.68rem;\n  }\n\n  .dashboard-summary-title {\n    font-size: 0.92rem;\n  }\n\n  .dashboard-summary-value,\n  .dashboard-mini-value {\n    font-size: 1.5rem;\n  }\n\n  .dashboard-mini-title {\n    font-size: 0.76rem;\n  }\n\n  .dashboard-summary-split {\n    margin-top: 0.9rem;\n  }\n\n  .dashboard-summary-split-item {\n    padding-top: 0.65rem;\n  }\n\n  .dashboard-summary-split-item + .dashboard-summary-split-item {\n    padding-left: 0.75rem;\n    margin-left: 0.75rem;\n  }\n\n  .dashboard-summary-split-label,\n  .dashboard-summary-stat-label {\n    font-size: 0.76rem;\n  }\n\n  .dashboard-summary-split-value,\n  .dashboard-summary-stat-value {\n    font-size: 1rem;\n  }\n\n  .dashboard-summary-stats {\n    gap: 0.6rem;\n    margin-top: 0.85rem;\n  }\n\n  .dashboard-page .card-header {\n    padding-left: 1rem !important;\n    padding-right: 1rem !important;\n    padding-top: 1.15rem !important;\n  }\n\n  .dashboard-page .card-body.px-4,\n  .dashboard-page .card-body.p-4 {\n    padding: 1rem !important;\n  }\n\n  .dashboard-page .card-body.px-4 {\n    padding-top: 0.5rem !important;\n  }\n}\n\n@media (max-width: 575.98px) {\n  .dashboard-summary-value,\n  .dashboard-mini-value {\n    font-size: 1.4rem;\n  }\n\n  .dashboard-summary-stat-label {\n    font-size: 0.7rem;\n  }\n\n  .dashboard-summary-stat-value {\n    font-size: 0.95rem;\n  }\n\n  .dashboard-summary-dot {\n    width: 6px;\n    height: 6px;\n    margin-right: 0.3rem;\n  }\n\n  .dashboard-page .card-body.p-4,\n  .dashboard-page .card-body.px-4 {\n    padding: 0.9rem !important;\n  }\n\n  .dashboard-page .card-body.px-0 {\n    padding-left: 0 !important;\n    padding-right: 0 !important;\n  }\n}\n\n.table thead th {\n  background-color: #f8fafc;\n  color: #64748b;\n  font-size: 0.75rem;\n  text-transform: uppercase;\n  font-weight: 700;\n  letter-spacing: 0.5px;\n  padding: 0.75rem 1.5rem;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.table tbody td {\n  padding: 1rem 1.5rem;\n  font-size: 0.875rem;\n  vertical-align: middle;\n}\n\n.badge {\n  padding: 0.4em 0.75em;\n  font-weight: 600;\n  border-radius: 6px;\n}\n\n.badge-soft-success {\n  background-color: #dcfce7;\n  color: #15803d;\n}\n\n.badge-soft-warning {\n  background-color: #fef9c3;\n  color: #854d0e;\n}\n\n.badge-soft-danger {\n  background-color: #fee2e2;\n  color: #b91c1c;\n}\n\n.badge-soft-primary {\n  background-color: #dbeafe;\n  color: #1d4ed8;\n}\n\n.badge-soft-info {\n  background-color: #cffafe;\n  color: #0e7490;\n}\n\n.badge-soft-secondary {\n  background-color: #e2e8f0;\n  color: #475569;\n}\n\n/* Soft Backgrounds */\n.bg-soft-primary { background-color: #eff6ff !important; }\n.bg-soft-success { background-color: #f0fdf4 !important; }\n.bg-soft-warning { background-color: #fffbeb !important; }\n.bg-soft-danger { background-color: #fef2f2 !important; }\n.bg-soft-info { background-color: #f0f9ff !important; }\n.bg-soft-dark { background-color: #f1f5f9 !important; }\n\n.text-primary { color: #2563eb !important; }\n.text-success { color: #16a34a !important; }\n.text-warning { color: #d97706 !important; }\n.text-danger { color: #dc2626 !important; }\n.text-info { color: #0891b2 !important; }\n\n/* Buttons */\n.btn {\n  font-weight: 500;\n  padding: 0.5rem 1rem;\n  border-radius: 0.5rem;\n}\n\n.btn-primary {\n  background-color: #2563eb;\n  border-color: #2563eb;\n}\n\n.btn-primary:hover {\n  background-color: #1d4ed8;\n  border-color: #1d4ed8;\n}\n\n/* Utilities */\n.text-xs { font-size: 0.75rem; }\n.text-sm { font-size: 0.875rem; }\n.fw-600 { font-weight: 600; }\n.fw-700 { font-weight: 700; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
